import React from 'react';
import { Icon } from '@chakra-ui/react';

export const InstagramLogo = () => {
	return (
		<Icon
			width="12px"
			height="12px"
			viewBox="0 0 9 9"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.10455 1.33789H2.74579C1.81829 1.33789 1.06641 2.08977 1.06641 3.01727V6.37603C1.06641 7.30353 1.81829 8.05541 2.74579 8.05541H6.10455C7.03204 8.05541 7.78393 7.30353 7.78393 6.37603V3.01727C7.78393 2.08977 7.03204 1.33789 6.10455 1.33789Z"
				stroke="white"
				stroke-width="0.787824"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M5.77013 4.4853C5.81158 4.76483 5.76384 5.05032 5.63369 5.30115C5.50353 5.55198 5.2976 5.75539 5.04519 5.88244C4.79277 6.00949 4.50672 6.05371 4.22772 6.00881C3.94872 5.96392 3.69098 5.83219 3.49116 5.63237C3.29134 5.43255 3.15962 5.17481 3.11472 4.89581C3.06983 4.61682 3.11405 4.33076 3.2411 4.07835C3.36815 3.82593 3.57155 3.62 3.82238 3.48985C4.07322 3.3597 4.3587 3.31195 4.63823 3.3534C4.92336 3.39568 5.18734 3.52855 5.39116 3.73237C5.59499 3.9362 5.72785 4.20017 5.77013 4.4853Z"
				stroke="white"
				stroke-width="0.787824"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.27344 2.84961H6.27818"
				stroke="white"
				stroke-width="0.787824"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</Icon>
	);
};

export default InstagramLogo;
